import React, { useEffect} from 'react';
import { drawChart } from './drawChart';

export interface IPieChart {
	className: string,
	containerId: string,
	percent: number,
	text: string,
};

const PieChart: React.FC<IPieChart> = ({ percent, containerId, text, className }) => {

  useEffect(() => {
    drawChart( percent, containerId, text);
  }, [percent, containerId, text]);

	return (
		<div className={className} id={containerId} />
	);
};

export default PieChart;
